import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";
import React from "react";

export const Loading = () => {
  return (
    <div className="cw-flex cw-flex-col cw-justify-center cw-h-[500px] cw-items-center">
      <CircularProgress />
    </div>
  );
};
